// @flow

import React from 'react';
import { Link } from 'react-router-dom';

import makeUrl from '../../../lib/makeUrl';

type Props = {
  place: Object,
  region: String,
};

export default function DaySummaryPlaceName({ place, region }: Props) {
  return (
    <li>
      <div className="place-wrap">
        <h5>
          <Link to={makeUrl.placeDetails(place.name, place.id, region)}>
            {place.name.toUpperCase()}
          </Link>
        </h5>
        <p>{place.altitude && place.altitude.meters.toLocaleString()} m</p>
      </div>
    </li>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Trek/DaySummary/DaySummaryPlaceName.js